// generated by genversion
export var version = '4.1.1';
//# sourceMappingURL=version.js.map